import { IJornadaEtapa } from "../../../../Interfaces/Geral/GestaoDeCadastro/JornadaEtapa/JornadaEtapaInterface";
import {
    AtualizarJornadaEtapaService,
    CadastrarJornadaEtapaService,
    ExcluirJornadaEtapaService,
    GetJornadaEtapaService,
    ListarJornadaEtapaService,
    VincularEtapaJornadaService,
} from "../../../../Services/Geral/JornadaEtapa/JornadaEtapaService";
import { Controller } from "../../../Controller";

export async function CadastrarJornadaEtapaController(data: IJornadaEtapa) {
    return Controller(CadastrarJornadaEtapaService(data));
}

export async function AtualizarJornadaEtapaController(data: IJornadaEtapa) {
    return Controller(AtualizarJornadaEtapaService(data));
}

export async function ListarJornadaEtapaController(FL_ATIVO?: boolean) {
    return Controller(ListarJornadaEtapaService(FL_ATIVO));
}

export async function ExcluirJornadaEtapaController(idEtapaJornada: number) {
    return Controller(ExcluirJornadaEtapaService(idEtapaJornada));
}

export async function GetJornadaEtapaController(idEtapaJornada: number) {
    return Controller(GetJornadaEtapaService(idEtapaJornada));
}

export async function VincularEtapaJornadaController(
    idUnidade: number,
    idConta: number,
    idEtapaJornada: number
) {
    return Controller(
        VincularEtapaJornadaService(idUnidade, idConta, idEtapaJornada)
    );
}
